import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Header from '../../components/Header'; // Use the local NavBar
import Header2 from '../../components/Header2'; // Use the local NavBar

import Slideshow from '../../components/slideshow';
import NowPlaying from '../../components/NowPlaying';
import HolidayPromo from '../../components/Holiday';
import Footer from '../../components/Footer';
import './HomePage.css';

// Matches Header.css's own desktop/mobile breakpoint (900px) - Header2 is a
// second desktop-only nav row that sits below the main header, so it must
// switch at the same point the main header does, or there's a range where
// Header2 renders under a header that's already collapsed into mobile mode.
const DESKTOP_BREAKPOINT = 900;

const Home = () => {

const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    };

    checkScreenSize(); // run on load
    window.addEventListener('resize', checkScreenSize); // update on resize

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


  return (
    <div className="home-root">
      <Header />
      {isDesktop && <Header2 />}
      {/* Hero Section */}
      <section className="hero-section">
      <Slideshow/>
      </section>
      {/* Now Playing Section - intentionally full-bleed (no .container),
          so the row visually runs off both edges of the screen. */}
      <section id="now-playing" className="nowplaying-section">
        <NowPlaying />
      </section>
      {/* Promo Section: concessions / event promos */}
      <section className="promo-section">
        <div className="container">
          <HolidayPromo />
        </div>
      </section>
      {/* App Download / Membership Section */}
      <section className="app-download-section">
        <div className="container">
          <div className="membership-card-creative">
            <div className="membership-sparkles-bg"></div>
            <div className="membership-ribbon">Download the App</div>
            <div className="membership-icon-creative">
              {/* Custom SVG ticket icon */}
              <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7" y="13" width="40" height="28" rx="8" fill="url(#ticketGradient)"/>
                <circle cx="27" cy="27" r="7" fill="#fff" fillOpacity="0.7"/>
                <rect x="17" y="23" width="20" height="8" rx="4" fill="#fff" fillOpacity="0.5"/>
                <defs>
                  <linearGradient id="ticketGradient" x1="7" y1="13" x2="47" y2="41" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#8A2BE2"/>
                    <stop offset="1" stopColor="#87CEEB"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <h2 className="membership-title-creative">Unlock <span className="gradient-text">StarView X</span> Membership</h2>
            <ul className="membership-benefits-creative">
              <li><span className="checkmark">✔</span> Earn points on every ticket & snack</li>
              <li><span className="checkmark">✔</span> Exclusive rewards & discounts</li>
              <li><span className="checkmark">✔</span> Early access to tickets & events</li>
              <li><span className="checkmark">✔</span> All tickets & points sync instantly with our app</li>
            </ul>
            <Link to="/Login" className="membership-btn-bounce">Create Your Account</Link>
            <div className="membership-note-creative">One account works on the website and the app - your tickets and points sync instantly either way.</div>
            <div className="membership-app-download-creative">
              {/* The mobile app isn't published to the App Store / Play Store
                  yet - showing real badges linking to those stores would
                  point to someone else's unrelated app. Honest "coming soon"
                  placeholder instead. */}
              <div className="membership-app-badges-creative membership-app-badges-soon">
                <span className="app-badge-soon">App Store — Coming Soon</span>
                <span className="app-badge-soon">Google Play — Coming Soon</span>
              </div>
              <div className="membership-spotlight"></div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
  